// Bilingual translations for Soccer Troop
export const translations = {
  es: {
    // Top
    language: "Idioma",
    spanish: "Español",
    english: "English",
    brand_name: "SOCCER TROOP",
    tagline: "Train · Focus · Score",
    location: "Denver, Colorado · Est. 2022",
    instagram: "@soccer.troop",
    admin_link: "Admin",
    home_link: "Inicio",

    // Hero
    hero_title: "REGISTRO DE JUGADOR",
    hero_subtitle: "Únete a la Tropa. Llena el formulario para inscribir a tu jugador.",

    // Player number
    player_number_label: "Número de Jugador",
    player_number_help: "Único para cada jugador. Sugerido automáticamente.",
    checking: "Verificando...",
    number_available: "Disponible",
    number_taken: "Ya en uso. Elige otro.",
    number_required: "Requerido",

    // Section 1
    section_player: "Información del Jugador",
    first_name: "Nombre",
    last_name: "Apellido",
    date_of_birth: "Fecha de nacimiento",
    age: "Edad",
    gender: "Género",
    gender_male: "Masculino",
    gender_female: "Femenino",
    gender_other: "Prefiero no decirlo",
    select: "Selecciona...",
    primary_position: "Posición principal",
    pos_forward: "Delantero",
    pos_midfielder: "Mediocampista",
    pos_defender: "Defensa",
    pos_goalkeeper: "Portero",
    dominant_foot: "Pie dominante",
    foot_right: "Derecho",
    foot_left: "Izquierdo",
    foot_both: "Ambos",
    current_club: "Equipo / club actual (opcional)",
    experience: "Nivel de experiencia",
    exp_beginner: "Principiante",
    exp_intermediate: "Intermedio",
    exp_advanced: "Avanzado",
    exp_competitive: "Competitivo",

    // Section 2
    section_parent: "Padre / Madre / Tutor",
    parent_full_name: "Nombre completo",
    relationship: "Parentesco con el jugador",
    rel_father: "Padre",
    rel_mother: "Madre",
    rel_guardian: "Tutor legal",
    rel_other: "Otro",
    email: "Correo electrónico",
    phone: "Teléfono / WhatsApp",
    emergency_contact: "Contacto de emergencia",
    emergency_name: "Nombre",
    emergency_phone: "Teléfono",

    // Section 3
    section_medical: "Información Médica",
    has_medical: "¿Tiene alguna condición médica?",
    yes: "Sí",
    no: "No",
    medical_details: "Describe la condición médica",
    allergies: "Alergias",
    medications: "Medicamentos actuales",
    insurance_box_title: "Seguro Médico",
    insurance_provider: "Proveedor de seguro",
    insurance_policy: "Póliza / Número de miembro",
    insurance_emergency: "Teléfono de emergencia del seguro",

    // Section 4
    section_consent: "Autorizaciones y Consentimiento",
    consent_marketing_title: "Marketing",
    consent_marketing_text: "Autorizo a Soccer Troop a contactarme por correo electrónico, teléfono y WhatsApp para promociones y actualizaciones del programa.",
    consent_social_title: "Redes Sociales",
    consent_social_text: "Autorizo a Soccer Troop a fotografiar y grabar a mi hijo/a durante los entrenamientos y publicar el material en Instagram, Facebook, YouTube y TikTok con fines promocionales.",
    consent_insurance_title: "Renuncia de Seguro",
    consent_insurance_text: "Confirmo que mi hijo/a cuenta con seguro médico personal vigente. Soccer Troop NO asume responsabilidad financiera por gastos médicos o emergencias derivadas de lesiones.",
    consent_liability_title: "Renuncia de Responsabilidad",
    consent_liability_text: "Reconozco los riesgos físicos del entrenamiento de fútbol y libero a Soccer Troop de cualquier responsabilidad por lesiones accidentales.",
    consent_general_title: "Confirmación General",
    consent_general_text: "La información proporcionada es verídica. Soccer Troop puede actualizar los términos con previo aviso.",
    legal_note: "Al firmar este formulario, aceptas todos los términos y autorizaciones anteriores. Este consentimiento aplica para toda la duración de la participación de tu hijo/a en el programa Soccer Troop.",
    signature_label: "Firma digital del padre/tutor",
    signature_help: "Firma con el dedo (móvil) o el ratón.",
    clear_signature: "Borrar",
    guardian_printed: "Nombre impreso del padre/tutor",
    date_signed: "Fecha de firma",

    // Submit
    submit: "Completar Registro",
    submitting: "Enviando...",
    required_marker: "*",
    required_field: "Campo requerido",
    invalid_email: "Correo inválido",
    invalid_phone: "Teléfono inválido",
    must_accept_all: "Debes aceptar todos los consentimientos",
    signature_required: "La firma es requerida",
    error_generic: "Error al guardar. Intenta de nuevo.",
    fix_errors: "Corrige los errores marcados",

    // Success
    success_title: "¡REGISTRO COMPLETO!",
    success_message: "Gracias por unirte a Soccer Troop. Te contactaremos pronto con los detalles del programa.",
    success_player: "Jugador",
    new_registration: "Nuevo Registro",

    // Admin
    admin_title: "PANEL ADMIN",
    admin_subtitle: "Acceso al panel de Soccer Troop",
    password: "Contraseña",
    enter: "Entrar",
    invalid_password: "Contraseña incorrecta",
    logout: "Salir",
    search: "Buscar nombre, número, posición...",
    filter_position: "Filtrar posición",
    all_positions: "Todas las posiciones",
    export_csv: "Exportar CSV",
    download_pdf: "PDF",
    total_players: "Jugadores Totales",
    no_players: "No hay jugadores registrados aún",
    table_number: "#",
    table_name: "Nombre",
    table_age: "Edad",
    table_position: "Posición",
    table_foot: "Pie",
    table_club: "Club",
    table_parent: "Padre/Tutor",
    table_email: "Email",
    table_phone: "WhatsApp",
    table_insurance: "Seguro",
    table_date: "Registrado",
    table_actions: "Acciones",
    edit: "Editar",
    edit_player: "Editar Jugador",
    delete: "Eliminar",
    delete_confirm: "¿Eliminar este registro permanentemente?",
    save: "Guardar",
    saving: "Guardando...",
    cancel: "Cancelar",
    edit_saved: "Cambios guardados",
    delete_success: "Registro eliminado",
    share_title: "Comparte tu link de registro",
    share_subtitle: "Cópialo, compártelo por WhatsApp o ponlo en tu bio de Instagram",
    copy_link: "Copiar link",
    copied: "¡Copiado!",
    share_whatsapp: "WhatsApp",
    share_email: "Email",
    share_qr: "Mostrar QR",
    share_qr_close: "Cerrar QR",
    share_message: "⚽ ¡Inscripciones abiertas para Soccer Troop! Llena el formulario desde tu celular — solo toma 2 minutos. 👉 ",

    // Profile / Trainings / Notes
    back: "Volver",
    profile: "Perfil",
    tab_info: "Información",
    tab_trainings: "Entrenamientos",
    tab_notes: "Notas",
    tab_stats: "Estadísticas",
    view_profile: "Ver perfil",
    calendar: "Calendario",
    new_training: "Nuevo Entrenamiento",
    edit_training: "Editar Entrenamiento",
    training_title: "Título de la sesión",
    training_date: "Fecha",
    training_time: "Hora",
    training_location: "Ubicación",
    training_duration: "Duración (minutos)",
    training_description: "Descripción / objetivos",
    notify_parents: "Notificar a los padres por email",
    mark_attendance: "Marcar Asistencia",
    attendance: "Asistencia",
    present: "Presente",
    absent: "Ausente",
    late: "Tarde",
    excused: "Excusado",
    not_marked: "Sin marcar",
    save_attendance: "Guardar Asistencia",
    no_trainings: "No hay entrenamientos programados",
    upcoming_trainings: "Próximos entrenamientos",
    past_trainings: "Entrenamientos pasados",
    attendance_rate: "Tasa de asistencia",
    total_sessions: "Sesiones totales",
    add_note: "Agregar nota",
    note_placeholder: "Escribe una observación sobre este jugador...",
    no_notes: "No hay notas aún",
    delete_note: "Eliminar nota",
    contact: "Contacto",
    medical: "Médico",
    consent_status: "Consentimientos",
    accepted: "Aceptado",
    months: "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    weekdays: "Dom,Lun,Mar,Mié,Jue,Vie,Sáb",
    today: "Hoy",
    no_registrations: "No hay registros",

    // Parent portal
    parent_portal: "Portal del Padre",
    welcome_back: "Bienvenido",
    my_profile: "Mi Perfil",
    team_calendar: "Calendario del Equipo",
    private_session: "Sesión Privada",
    request_private: "Solicitar sesión privada",
    my_requests: "Mis Solicitudes",
    rsvp_yes: "Sí voy",
    rsvp_no: "No puedo",
    rsvp_maybe: "Tal vez",
    confirmed: "Confirmado",
    declined: "Rechazado",
    requested_session: "Sesión solicitada",
    request_notes: "Notas (opcional)",
    request_submit: "Enviar solicitud",
    pending: "Pendiente",
    approved: "Aprobado",
    private_requests: "Solicitudes Privadas",
    approve: "Aprobar",
    decline: "Rechazar",
    no_requests: "No hay solicitudes pendientes",
    readonly_notice: "Solo lectura · Para cambios, contacta al coach",
    invalid_link: "Link inválido o expirado",

    payments: "Pagos",
    bookings: "Reservas",
    my_bookings: "Mis Reservas",
    payment_status: "Estado de pago",
    pay_now: "Pagar ahora",
    paid: "Pagado",
    pending_payment: "Pago pendiente",
    payment_failed: "Pago falló",
    payment_cancelled: "Pago cancelado",
    spot_confirmed: "Lugar confirmado",
    spot_not_confirmed: "Lugar NO confirmado hasta pagar",
    amount: "Monto",
    service: "Servicio",
    booking_date: "Fecha de reserva",
    payment_date: "Fecha de pago",
    total_month: "Este mes",
    total_bookings: "Reservas totales",
    new_manual_booking: "Reserva manual",
    training_price: "Precio (USD)",
    training_max_players: "Máx. jugadores",
    training_type: "Tipo de entrenamiento",
    tt_private_1: "Privado · 1 jugador ($70)",
    tt_private_2: "Privado · 2 jugadores ($100 total)",
    tt_group: "Grupal · 3+ jugadores ($45 c/u)",
    tt_camp: "Camp / Programa especial",
    tt_custom: "Personalizado / Gratis",
    processing_payment: "Procesando pago...",
    payment_successful: "¡Pago exitoso! Tu lugar está confirmado.",
    paypal_not_configured: "Los pagos aún no están configurados. Contacta al coach.",
    filter_all: "Todos",
    no_bookings: "No hay reservas aún",

    videos: "Videos",
    tab_videos: "Videos",
    upload_video: "Subir video",
    uploading: "Subiendo...",
    video_title: "Título del video",
    video_category: "Categoría",
    video_description: "Notas",
    video_tags: "Etiquetas (separadas por coma)",
    video_session_date: "Fecha de sesión",
    cat_technique: "Técnica",
    cat_match: "Partido",
    cat_training: "Entrenamiento",
    cat_progress_before: "Antes",
    cat_progress_after: "Después",
    cat_other: "Otro",
    compare_side_by_side: "Comparar lado a lado",
    select_two_videos: "Selecciona 2 videos para comparar",
    exit_compare: "Salir de comparación",
    sync_play: "Reproducción sincronizada",
    no_videos: "No hay videos aún",
    file_too_large: "El archivo excede 500MB",
    download: "Descargar",

    // Player Development (Phase 2 P0)
    development: "Desarrollo",
    tab_development: "Desarrollo",
    development_title: "Desarrollo del Jugador",
    development_subtitle: "Formación individual · qué mejoró, qué falta, próximo objetivo",
    dev_session: "Sesión de desarrollo",
    dev_new_session: "Nueva sesión de coach",
    dev_edit_session: "Editar sesión",
    dev_skill_worked: "Habilidad trabajada",
    dev_skill_placeholder: "Ej: Pase con pie izquierdo",
    dev_objective: "Objetivo de la sesión",
    dev_objective_placeholder: "Ej: Aumentar precisión a 15 metros",
    dev_what_improved: "Qué mejoró",
    dev_what_improved_placeholder: "Ej: Mejor peso del pase, mejor postura",
    dev_what_needs_work: "Qué falta mejorar",
    dev_what_needs_work_placeholder: "Ej: Primer toque al recibir",
    dev_homework: "Tarea para casa",
    dev_homework_placeholder: "Ej: 20 min de pases contra la pared, diario",
    dev_next_objective: "Próximo objetivo",
    dev_next_objective_placeholder: "Ej: Presión 1v1 en el mediocampo",
    dev_coach_notes: "Notas del coach (privado)",
    dev_before_video: "Video · Antes",
    dev_after_video: "Video · Después",
    dev_select_video: "Selecciona un video",
    dev_none: "Ninguno",
    dev_no_sessions: "Aún no hay sesiones de desarrollo",
    dev_add_first_session: "Agrega la primera sesión estructurada",
    dev_delete_confirm: "¿Eliminar esta sesión de desarrollo?",
    dev_save_session: "Guardar sesión",
    dev_timeline: "Timeline de desarrollo",
    dev_timeline_empty: "Aún no hay actividad de desarrollo",
    dev_event_registration: "Registro completo",
    dev_event_training: "Entrenamiento",
    dev_event_video: "Nuevo video",
    dev_event_coach: "Sesión con coach",
    dev_before_after_title: "Antes vs Después",
    dev_progress_summary: "Resumen de progreso",

    // Premium lock
    premium_locked_title: "Contenido Premium",
    premium_locked_message: "Desbloquea el desarrollo completo de tu hijo/a: videos privados, feedback estructurado del coach, timeline de progreso y comparativas Antes/Después.",
    premium_locked_cta: "Pagar y desbloquear",
    premium_locked_pending: "Tienes un pago pendiente",
    premium_locked_go_bookings: "Ver mis reservas",
    premium_locked_no_booking: "No tienes reservas activas. Contacta al coach para iniciar el programa.",
    premium_unlocked: "Contenido Premium desbloqueado",
    coach_feedback: "Feedback del coach",
    session_from: "Sesión del",
    watch_before: "Ver Antes",
    watch_after: "Ver Después",

    // Skills Tracking
    tab_skills: "Skills",
    skills: "Habilidades",
    skills_tracking: "Skills Tracking · 1-10",
    skills_new_eval: "Nueva evaluación",
    skills_edit_eval: "Editar evaluación",
    skills_overall: "Promedio general",
    skills_evaluations_count: "Total de evaluaciones",
    skills_last_eval: "Última evaluación",
    skills_history: "Historial de evaluaciones",
    skills_notes: "Notas de la evaluación",
    evaluation_date: "Fecha de evaluación",
  },

  en: {
    language: "Language",
    spanish: "Español",
    english: "English",
    brand_name: "SOCCER TROOP",
    tagline: "Train · Focus · Score",
    location: "Denver, Colorado · Est. 2022",
    instagram: "@soccer.troop",
    admin_link: "Admin",
    home_link: "Home",

    hero_title: "PLAYER REGISTRATION",
    hero_subtitle: "Join the Troop. Fill out the form to register your player.",

    player_number_label: "Player Number",
    player_number_help: "Unique for each player. Auto-suggested.",
    checking: "Checking...",
    number_available: "Available",
    number_taken: "Already in use. Pick another.",
    number_required: "Required",

    section_player: "Player Info",
    first_name: "First name",
    last_name: "Last name",
    date_of_birth: "Date of birth",
    age: "Age",
    gender: "Gender",
    gender_male: "Male",
    gender_female: "Female",
    gender_other: "Prefer not to say",
    select: "Select...",
    primary_position: "Primary position",
    pos_forward: "Forward",
    pos_midfielder: "Midfielder",
    pos_defender: "Defender",
    pos_goalkeeper: "Goalkeeper",
    dominant_foot: "Dominant foot",
    foot_right: "Right",
    foot_left: "Left",
    foot_both: "Both",
    current_club: "Current team / club (optional)",
    experience: "Experience level",
    exp_beginner: "Beginner",
    exp_intermediate: "Intermediate",
    exp_advanced: "Advanced",
    exp_competitive: "Competitive",

    section_parent: "Parent / Guardian",
    parent_full_name: "Full name",
    relationship: "Relationship to player",
    rel_father: "Father",
    rel_mother: "Mother",
    rel_guardian: "Legal guardian",
    rel_other: "Other",
    email: "Email address",
    phone: "Phone / WhatsApp",
    emergency_contact: "Emergency contact",
    emergency_name: "Name",
    emergency_phone: "Phone",

    section_medical: "Medical Information",
    has_medical: "Any medical condition?",
    yes: "Yes",
    no: "No",
    medical_details: "Describe the medical condition",
    allergies: "Allergies",
    medications: "Current medications",
    insurance_box_title: "Health Insurance",
    insurance_provider: "Insurance provider",
    insurance_policy: "Policy / Member ID",
    insurance_emergency: "Insurance emergency phone",

    section_consent: "Authorizations & Consent",
    consent_marketing_title: "Marketing",
    consent_marketing_text: "I authorize Soccer Troop to contact me via email, phone, and WhatsApp for promotions and program updates.",
    consent_social_title: "Social Media",
    consent_social_text: "I authorize Soccer Troop to photograph and video my child during training and publish the material on Instagram, Facebook, YouTube, and TikTok for promotional purposes.",
    consent_insurance_title: "Insurance Waiver",
    consent_insurance_text: "I confirm my child has valid personal health insurance. Soccer Troop assumes NO financial responsibility for medical expenses or emergencies arising from injuries.",
    consent_liability_title: "Liability Waiver",
    consent_liability_text: "I acknowledge the physical risks of soccer training and release Soccer Troop from any liability for accidental injuries.",
    consent_general_title: "General Confirmation",
    consent_general_text: "The information provided is truthful. Soccer Troop may update terms with prior notice.",
    legal_note: "By signing this form, you accept all terms and authorizations above. This consent applies for the entire duration of your child's participation in the Soccer Troop program.",
    signature_label: "Parent/Guardian digital signature",
    signature_help: "Sign with your finger (mobile) or mouse.",
    clear_signature: "Clear",
    guardian_printed: "Guardian's printed name",
    date_signed: "Date signed",

    submit: "Complete Registration",
    submitting: "Submitting...",
    required_marker: "*",
    required_field: "Required field",
    invalid_email: "Invalid email",
    invalid_phone: "Invalid phone",
    must_accept_all: "You must accept all consents",
    signature_required: "Signature is required",
    error_generic: "Save failed. Please try again.",
    fix_errors: "Fix the highlighted errors",

    success_title: "REGISTRATION COMPLETE!",
    success_message: "Thanks for joining Soccer Troop. We'll contact you soon with program details.",
    success_player: "Player",
    new_registration: "New Registration",

    admin_title: "ADMIN PANEL",
    admin_subtitle: "Access the Soccer Troop dashboard",
    password: "Password",
    enter: "Enter",
    invalid_password: "Invalid password",
    logout: "Logout",
    search: "Search name, number, position...",
    filter_position: "Filter position",
    all_positions: "All positions",
    export_csv: "Export CSV",
    download_pdf: "PDF",
    total_players: "Total Players",
    no_players: "No players registered yet",
    table_number: "#",
    table_name: "Name",
    table_age: "Age",
    table_position: "Position",
    table_foot: "Foot",
    table_club: "Club",
    table_parent: "Parent/Guardian",
    table_email: "Email",
    table_phone: "WhatsApp",
    table_insurance: "Insurance",
    table_date: "Registered",
    table_actions: "Actions",
    edit: "Edit",
    edit_player: "Edit Player",
    delete: "Delete",
    delete_confirm: "Permanently delete this registration?",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit_saved: "Changes saved",
    delete_success: "Record deleted",
    share_title: "Share your registration link",
    share_subtitle: "Copy it, share via WhatsApp, or put it in your Instagram bio",
    copy_link: "Copy link",
    copied: "Copied!",
    share_whatsapp: "WhatsApp",
    share_email: "Email",
    share_qr: "Show QR",
    share_qr_close: "Close QR",
    share_message: "⚽ Soccer Troop registration is open! Fill out the form from your phone — only takes 2 minutes. 👉 ",

    back: "Back",
    profile: "Profile",
    tab_info: "Info",
    tab_trainings: "Trainings",
    tab_notes: "Notes",
    tab_stats: "Stats",
    view_profile: "View profile",
    calendar: "Calendar",
    new_training: "New Training",
    edit_training: "Edit Training",
    training_title: "Session title",
    training_date: "Date",
    training_time: "Time",
    training_location: "Location",
    training_duration: "Duration (minutes)",
    training_description: "Description / objectives",
    notify_parents: "Notify parents by email",
    mark_attendance: "Mark Attendance",
    attendance: "Attendance",
    present: "Present",
    absent: "Absent",
    late: "Late",
    excused: "Excused",
    not_marked: "Not marked",
    save_attendance: "Save Attendance",
    no_trainings: "No trainings scheduled",
    upcoming_trainings: "Upcoming trainings",
    past_trainings: "Past trainings",
    attendance_rate: "Attendance rate",
    total_sessions: "Total sessions",
    add_note: "Add note",
    note_placeholder: "Write an observation about this player...",
    no_notes: "No notes yet",
    delete_note: "Delete note",
    contact: "Contact",
    medical: "Medical",
    consent_status: "Consents",
    accepted: "Accepted",
    months: "January,February,March,April,May,June,July,August,September,October,November,December",
    weekdays: "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    today: "Today",
    no_registrations: "No registrations",

    parent_portal: "Parent Portal",
    welcome_back: "Welcome",
    my_profile: "My Profile",
    team_calendar: "Team Calendar",
    private_session: "Private Session",
    request_private: "Request private session",
    my_requests: "My Requests",
    rsvp_yes: "I'll be there",
    rsvp_no: "Can't make it",
    rsvp_maybe: "Maybe",
    confirmed: "Confirmed",
    declined: "Declined",
    requested_session: "Requested session",
    request_notes: "Notes (optional)",
    request_submit: "Submit request",
    pending: "Pending",
    approved: "Approved",
    private_requests: "Private Requests",
    approve: "Approve",
    decline: "Decline",
    no_requests: "No pending requests",
    readonly_notice: "Read-only · For changes, contact the coach",
    invalid_link: "Invalid or expired link",

    // Payments
    payments: "Payments",
    bookings: "Bookings",
    my_bookings: "My Bookings",
    payment_status: "Payment status",
    pay_now: "Pay now",
    paid: "Paid",
    pending_payment: "Pending payment",
    payment_failed: "Payment failed",
    payment_cancelled: "Payment cancelled",
    spot_confirmed: "Spot confirmed",
    spot_not_confirmed: "Spot NOT confirmed until payment",
    amount: "Amount",
    service: "Service",
    booking_date: "Booking date",
    payment_date: "Payment date",
    total_month: "This month",
    total_bookings: "Total bookings",
    new_manual_booking: "Manual booking",
    training_price: "Price (USD)",
    training_max_players: "Max players",
    training_type: "Training type",
    tt_private_1: "Private · 1 player ($70)",
    tt_private_2: "Private · 2 players ($100 total)",
    tt_group: "Group · 3+ players ($45 each)",
    tt_camp: "Camp / Special program",
    tt_custom: "Custom / Free",
    processing_payment: "Processing payment...",
    payment_successful: "Payment successful! Your spot is confirmed.",
    paypal_not_configured: "Payments are not yet configured. Contact the coach.",
    filter_all: "All",
    no_bookings: "No bookings yet",

    // Videos
    videos: "Videos",
    tab_videos: "Videos",
    upload_video: "Upload video",
    uploading: "Uploading...",
    video_title: "Video title",
    video_category: "Category",
    video_description: "Notes",
    video_tags: "Tags (comma separated)",
    video_session_date: "Session date",
    cat_technique: "Technique",
    cat_match: "Match",
    cat_training: "Training",
    cat_progress_before: "Before",
    cat_progress_after: "After",
    cat_other: "Other",
    compare_side_by_side: "Compare side-by-side",
    select_two_videos: "Select 2 videos to compare",
    exit_compare: "Exit comparison",
    sync_play: "Sync play",
    no_videos: "No videos yet",
    file_too_large: "File exceeds 500MB",
    download: "Download",

    // Player Development (Phase 2 P0)
    development: "Development",
    tab_development: "Development",
    development_title: "Player Development",
    development_subtitle: "Individual growth · what improved, what needs work, next objective",
    dev_session: "Development session",
    dev_new_session: "New coach session",
    dev_edit_session: "Edit session",
    dev_skill_worked: "Skill worked",
    dev_skill_placeholder: "Ex: Left foot passing",
    dev_objective: "Session objective",
    dev_objective_placeholder: "Ex: Increase accuracy at 15m",
    dev_what_improved: "What improved",
    dev_what_improved_placeholder: "Ex: Better weight of pass, better body posture",
    dev_what_needs_work: "What needs work",
    dev_what_needs_work_placeholder: "Ex: First touch on receiving",
    dev_homework: "Homework",
    dev_homework_placeholder: "Ex: 20 min wall passes, daily",
    dev_next_objective: "Next objective",
    dev_next_objective_placeholder: "Ex: 1v1 pressing in midfield",
    dev_coach_notes: "Coach notes (private)",
    dev_before_video: "Before video",
    dev_after_video: "After video",
    dev_select_video: "Select a video",
    dev_none: "None",
    dev_no_sessions: "No development sessions yet",
    dev_add_first_session: "Add the first structured session",
    dev_delete_confirm: "Delete this development session?",
    dev_save_session: "Save session",
    dev_timeline: "Development timeline",
    dev_timeline_empty: "No development activity yet",
    dev_event_registration: "Registration complete",
    dev_event_training: "Training",
    dev_event_video: "New video",
    dev_event_coach: "Coach session",
    dev_before_after_title: "Before vs After",
    dev_progress_summary: "Progress summary",

    // Premium lock
    premium_locked_title: "Premium Content",
    premium_locked_message: "Unlock your child's full development: private videos, structured coach feedback, progress timeline, and Before/After comparisons.",
    premium_locked_cta: "Pay & unlock",
    premium_locked_pending: "You have a pending payment",
    premium_locked_go_bookings: "Go to my bookings",
    premium_locked_no_booking: "No active bookings. Contact the coach to start the program.",
    premium_unlocked: "Premium content unlocked",
    coach_feedback: "Coach feedback",
    session_from: "Session from",
    watch_before: "Watch Before",
    watch_after: "Watch After",

    // Skills Tracking
    tab_skills: "Skills",
    skills: "Skills",
    skills_tracking: "Skills Tracking · 1-10",
    skills_new_eval: "New evaluation",
    skills_edit_eval: "Edit evaluation",
    skills_overall: "Overall average",
    skills_evaluations_count: "Total evaluations",
    skills_last_eval: "Last evaluation",
    skills_history: "Evaluation history",
    skills_notes: "Evaluation notes",
    evaluation_date: "Evaluation date",
  },
};
